import {
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverProps,
  PopoverTrigger,
} from '@chakra-ui/react';
import React from 'react';

type Props = {
  closeOnEsc?: boolean;
  closeOnBlur?: boolean;
  isOpen: boolean;
  handleOk?: () => void;
  onClose: () => void;
  button: React.ReactNode;
} & PopoverProps;

export const CmMiniPopover: React.FC<Props> = ({
  children,
  closeOnEsc = true,
  closeOnBlur = true,
  placement,
  isOpen,
  button,
  onClose,
  onOpen,
}) => {
  return (
    <Popover
      {...{
        closeOnEsc,
        closeOnBlur,
        isOpen,
        onClose,
        onOpen,
        placement,
      }}
    >
      <PopoverTrigger>{button}</PopoverTrigger>
      {/*
       // @ts-ignore TS2590 */}
      <PopoverContent>
        <PopoverBody>{children}</PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
